import {
    StackerAPI,
    StackerActions,
    FETCH_STARTED,
    FETCH_COMPLETED,
    fetchAndReturn,
    byID,
    without,
} from "./utils/utils"
import { createSelector } from "reselect"
import { groupBy, unique } from "utils/utils"
import { STACK_SELECTED } from "./stackApi"

// CONSTANTS
export const OBJECTS_FETCHED = "OBJECTS_FETCHED"
export const OBJECTS_CREATED = "OBJECTS_CREATED"
export const OBJECTS_UPDATED = "OBJECTS_UPDATED"
export const OBJECTS_REMOVED = "OBJECTS_REMOVED"
export const FIELDS_FETCHED = "FIELDS_FETCHED"
export const FIELDS_CREATED = "FIELDS_CREATED"
export const FIELDS_UPDATED = "FIELDS_UPDATED"
export const FIELDS_REMOVED = "FIELDS_REMOVED"

// API
class ObjectApi extends StackerAPI {
    path = "objects/"
    loadActions(id) {
        return fetchAndReturn("/api/" + id + "/actions/")
    }
}
const objectApi = new ObjectApi()
class FieldApi extends StackerAPI {
    path = "fields/"
    getObjectFields(objectId) {
        return fetchAndReturn(this.path, { query: { object_id: objectId } })
    }
    transformFromLocal = data => {
        const keys = Object.keys(data)
        let out = {}
        keys.forEach(key => {
            if (key.indexOf("options.") === -1) {
                out[key] = data[key]
            } else {
                const keyName = key.split(".")[1]
                let value = data[key]
                if (keyName === "options" && typeof data[key] === "string") {
                    // This is for options.options
                    value = []
                    data[key].split("\n").forEach(item => value.push({ label: item, value: item }))
                }
                out.options = { ...out.options, [keyName]: value }
            }
        })
        return out
    }
    // transformToLocal = data => {
    //     const keys = Object.keys(data)
    //     let out = {}
    //     keys.forEach(key => {
    //         if (key !== "options") {
    //             out[key] = data[key]
    //         }
    //     })
    //     Object.keys(data.options || {}).forEach(key => (out["options" + key] = data.options[key]))
    //     return out
    // }
}
const fieldApi = new FieldApi()

// ACTIONS
class ObjectActions extends StackerActions {
    api = objectApi
    reducer = "objects"
    actionTypes = {
        fetched: OBJECTS_FETCHED,
        removed: OBJECTS_REMOVED,
        created: OBJECTS_CREATED,
        updated: OBJECTS_UPDATED,
    }
    afterFetch = dispatch => {
        console.log("after")
        dispatch(fieldActions.fetch())
    }
}
class FieldActions extends StackerActions {
    api = fieldApi
    reducer = "objects"
    actionTypes = {
        fetched: FIELDS_FETCHED,
        removed: FIELDS_REMOVED,
        created: FIELDS_CREATED,
        updated: FIELDS_UPDATED,
    }

    processUpdate = (id, data) => {
        // Don't update from the API
    }
}
export const objectActions = new ObjectActions().actions
export const fieldActions = new FieldActions().actions

// REDUCERS
export function objectReducer(state = initialState, action) {
    var objects, object, fields, field, fetching
    switch (action.type) {
        case OBJECTS_FETCHED:
            objects = state.objects
            if (!action.id) objects = [...objects, ...action.payload.map(object => object._sid)]
            objects = unique(objects)
            return {
                ...state,
                objects,
                entities: { ...state.entities, ...byID(action.payload) },
            }
        case OBJECTS_CREATED:
            objects = [...state.objects, action.payload._sid]
            return {
                ...state,
                objects,
                entities: { ...state.entities, [action.payload._sid]: action.payload },
            }
        case OBJECTS_UPDATED:
            object = { ...state.entities[action.payload._sid], ...action.payload }
            return {
                ...state,
                entities: { ...state.entities, [object._sid]: object },
            }
        case OBJECTS_REMOVED:
            return {
                ...state,
                objects: without(state.objects, action.id),
            }
        case FIELDS_FETCHED:
            fields = state.fields
            if (!action.id) fields = groupFieldIDsByObjectId(action.payload)
            return {
                ...state,
                fields: { ...state.fields, ...fields },
                entities: { ...state.entities, ...byID(action.payload) },
            }
        case FIELDS_CREATED:
            fields = {
                ...state.fields,
                [action.payload.object_id]: [
                    ...(state.fields[action.payload.object_id] || []),
                    action.payload._sid,
                ],
            }
            return {
                ...state,
                fields,
                entities: { ...state.entities, [action.payload._sid]: action.payload },
            }
        case FIELDS_UPDATED:
            field = { ...state.entities[action.id], ...action.payload }
            return {
                ...state,
                entities: { ...state.entities, [field._sid]: field },
            }
        case FIELDS_REMOVED:
            fields = state.fields.map(fields => without(fields, action.id))
            return {
                ...state,
                fields,
            }

        case FETCH_STARTED:
            return { ...state, fetching: [...state.fetching, action.key] }
        case FETCH_COMPLETED:
            fetching = state.fetching.filter(item => item !== action.key)
            return { ...state, fetching: fetching }
        case STACK_SELECTED:
            return initialState
        default:
            return state
    }
}

// SELECTORS
export const getObjects = state => state.objects.objects.map(id => state.objects.entities[id])
export const getEntities = state => state.objects.objects.map(id => state.objects.entities[id])
export const getFieldsMap = state => {
    let fieldsMap = {}
    Object.keys(state.objects.fields).forEach(oId => {
        let fields = state.objects.fields[oId].map(id => state.objects.entities[id])
        fieldsMap[oId] = fields
    })
    return fieldsMap
}
export const getObjectsAndFields = createSelector(
    getObjects,
    getFieldsMap,
    (objects, fieldsMap) => {
        let returnObjects = objects.map(object => ({ ...object }))
        returnObjects.forEach(object => {
            object.fields = fieldsMap[object._sid] || []
        })
        return returnObjects
    }
)
export const getObjectsAndFieldsMap = createSelector(getObjectsAndFields, objects => {
    return byID(objects)
})

// HELPERS

const groupFieldIDsByObjectId = fields => {
    let fieldsByObj = groupBy(fields, "object_id")
    Object.keys(fieldsByObj).forEach(objId => {
        fieldsByObj[objId] = fieldsByObj[objId].map(field => field._sid)
    })
    return fieldsByObj
}

const initialActions = [
    {
        type: OBJECTS_FETCHED,
        payload: [
            { _sid: "app", is_metadata: true },
            { _sid: "page", is_metadata: true },
            { _sid: "object", is_metadata: true },
            { _sid: "field", is_metadata: true },
        ],
    },
    {
        type: FIELDS_FETCHED,
        payload: [
            {
                _sid: "app_name",
                api_name: "name",
                object_id: "app",
                type: "string",
                is_primary: true,
            },
            {
                _sid: "page_name",
                api_name: "name",
                object_id: "page",
                type: "string",
                is_primary: true,
            },
            {
                _sid: "page_id",
                api_name: "_sid",
                object_id: "page",
                type: "string",
            },
            {
                _sid: "page_app",
                label: "App",
                api_name: "app_id",
                object_id: "page",
                type: "lookup",
                options: {
                    lookup_target_id: "apps",
                },
            },
            {
                _sid: "page_url",
                label: "URL",
                api_name: "url",
                object_id: "page",
                type: "string",
            },
            {
                _sid: "object_name",
                label: "Name",
                api_name: "name",
                object_id: "object",
                type: "string",
                is_primary: true,
            },
            {
                _sid: "field_name",
                label: "Name",
                api_name: "name",
                object_id: "field",
                type: "string",
                is_primary: true,
            },
        ],
    },
]

const emptyState = {
    objects: [],
    fields: {},
    entities: {},
    fetching: [],
}

const initialState = initialActions.reduce(objectReducer, emptyState)



// WEBPACK FOOTER //
// ./src/data/objectApi.js